'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schema = undefined;

var _joi = require('joi');

var _joi2 = _interopRequireDefault(_joi);

var _constant = require('./constant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = exports.schema = {
  ncode: _joi2.default.string().regex(/^n[\d\w]+$/i).required()
};

exports.default = {
  url: _constant.protocol + '//api.syosetu.com/rank/rankin/',
  schema: _joi2.default.object(schema)
};


// WEBPACK FOOTER //
// ./src/api/fame.js